/* Network half of the Pursuit board move (pure half: ./pursuitMove.js).
 * Kept out of api.js so the concurrent 2026-10-26 lanes that edit api.js do
 * not collide with this one. [Jarvis · Claude] */
import { request } from './api.js'
import { moveBody } from './pursuitMove.js'
import { rangeToQuery } from './dateFilter.js'

/** POST /api/champion-update — the existing write route; RBAC is the server's. */
export const movePursuit = (record, to, requestId) =>
  request('/api/champion-update', { method: 'POST', body: moveBody(record, to),
    headers: {'X-SR-Pursuit-Request-Id':requestId},
    audit: { entity: 'championship', entityId: String(record.id), action: 'pursuit.move',
      before: { sr_pursuit_status: record.pursuit || 'Not Started' } } })

/** GET /api/pursuit-moves — the append-only move history (newest first). */
export const pursuitMoves = ({ range, ids, signal } = {}) =>
  request('/api/pursuit-moves', { signal, query: { ...rangeToQuery(range), ids: ids?.length ? ids.join(',') : undefined } })
